import React from 'react';
import PropTypes from 'prop-types';
import { View, Platform, StatusBar } from 'react-native';

import { JDNativeSystem, JDTouchableWithoutFeedback, JDText, JDImage } from '@jdreact/jdreact-core-lib';

import assets from './assets';
import MoreModal from './MoreModal';
import MoreModalShare from './MoreModal_share';
import { isJDAppWebView } from '../../utils/tools';

import styles from './index.style';

export default class JDCNavigationBar extends React.PureComponent {
  static contextTypes = {
    router: PropTypes.object,
  }

  static propTypes = {
    theme: PropTypes.oneOf(['dark', 'light']),
    containerStyle: PropTypes.object,
    /**
     * 整个导航条的样式
     */
    barContainerStyle: PropTypes.object,
    /**
     * 左容器样式，也即返回按钮容器
     */
    leftContainerStyle: PropTypes.object,
    /**
     * 中容器样式，也即title容器
     */
    middleContainerStyle: PropTypes.object,
    /**
     * 右容器样式，也即“显示更多”按钮容器
     */
    rightContainerStyle: PropTypes.object,

    /**
     * 自定义渲染背景部分
     */
    renderBg: PropTypes.func,

    /**
     * 自定义渲染左容器内容
     */
    renderLeft: PropTypes.func,

    /**
     * 自定义返回按钮点击事件
     */
    beforeBack: PropTypes.func,
    /**
     * 自定义渲染右容器内容
     */
    renderRight: PropTypes.func,
    /**
     * 自定义渲染中容器内容
     */
    renderMiddle: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.string,
    ]),

    /**
     * 是否显示更多按钮
     */
    showMoreButton: PropTypes.bool,

    /**
     * more中是否显示分享
     */
    hasShare: PropTypes.bool,

    /**
     * 默认样式下，提供navlist就可以渲染出来
     */
    moreNavDataList: PropTypes.array,

    /**
     * 自定义列表内容区
     */
    moreNavNodeList: PropTypes.arrayOf(PropTypes.node),

  }

  static defaultProps = {
    theme: 'light',
  }

  constructor(props) {
    super(props);
    this.moreModal = React.createRef()  // 创建Ref
    this.moreModalShare = React.createRef()  // 创建Ref
    this.back = this.back.bind(this);
  }

  /**
   * 内部渲染左容器逻辑:
   * 如果自定义，优先渲染自定义，
   * 如果未定义，提供默认样式
   */
  renderLeft() {
    if (typeof this.props.renderLeft === 'function') {
      return this.props.renderLeft();
    }
    return (
      <JDTouchableWithoutFeedback onPress={this.back} contentContainerStyle={styles.navBtn}>
        {this.props.theme === 'light'
          ? <JDImage source={assets.back_w} style={styles.backIcon} />
          : <JDImage source={assets.back} style={styles.backIcon} />
        }
      </JDTouchableWithoutFeedback>
    );
  }

  renderMiddle() {
    if (typeof this.props.renderMiddle === 'function') {
      return this.props.renderMiddle();
    }
    const color = this.props.theme === 'light' ? {} : { color: '#232326' };
    const textStyle = [styles.titleText, color];
    return (<JDText style={textStyle} numberOfLines={1}>{this.props.renderMiddle}</JDText>);
  }

  renderRight() {
    const { hasShare } = this.props;
    let rightButtons = [];
    if (typeof this.props.renderRight === 'function') {
      const cusRightBtns = this.props.renderRight();
      if (Array.isArray(cusRightBtns)) {
        rightButtons = rightButtons.concat(cusRightBtns);
      } else {
        rightButtons.push(cusRightBtns);
      }
    }
    if (this.props.showMoreButton) {
      rightButtons.push(<View key="item-more">
          <JDTouchableWithoutFeedback
            contentContainerStyle={styles.navBtn}
            onPress={() => { this.showModal(); } }
          >
            {this.props.theme === 'light'
              ? <JDImage source={assets.more_w} style={styles.moreIcon} />
              : <JDImage source={assets.more} style={styles.moreIcon} />
            }
          </JDTouchableWithoutFeedback>
          {hasShare ? <MoreModalShare ref={this.moreModalShare} moreNavList={this.props.moreNavDataList}>
            {this.props.moreNavNodeList}
          </MoreModalShare> : <MoreModal ref={this.moreModal} moreNavList={this.props.moreNavDataList}>
            {this.props.moreNavNodeList}
          </MoreModal>}
        </View>);
    }
    return rightButtons;
  }

  back() {
    if (this.props.beforeBack) {
      this.props.beforeBack()
    } else {
      this.context.router.goBack();
    }
    
  }

  /**
   * 自定义的modal必须提供onShow方法
   */
  showModal() {
    const { hasShare } = this.props;
    if (hasShare) {
      this.moreModalShare.current && this.moreModalShare.current.onShow();
    } else {
      this.moreModal.current && this.moreModal.current.onShow();
    }
    
  }

  setBgOpacity(opacity) {
    this.navBarBg && this.navBarBg.setNativeProps({opacity})
  }

  render() {
    const {
      bgStyle,
      containerStyle
    } = this.props
    // WQ 环境也需要隐藏h5的页头
    if (isJDAppWebView() || (Platform.OS === 'web' && /AND_SQ|IPH_SQ|micromessenger(\/[\d.]+)*/i.test(navigator.userAgent))) {
      return null;
    }

    return (
      <View style={[styles.navigationBarContainer, containerStyle, {backgroundColor: this.props.theme === 'dark' ? '#fff' : 'transparent'}]}>
        <StatusBar 
          translucent={true}
          barStyle='dark-content'
          backgroundColor="transparent"
        />
        <View ref={ref => this.navBarBg = ref} style={[styles.bg, bgStyle]}></View>
        <View style={[
          styles.navigationBar,
          this.props.theme === 'dark' ? { backgroundColor: '#fff' } : null,
          this.props.barContainerStyle,
        ]}>
          <View style={styles.left}>{this.renderLeft()}</View>
          <View style={styles.middle}>{this.renderMiddle()}</View>
          <View style={styles.right}>{this.renderRight()}</View>
        </View>
      </View>
    );
  }
}

